import useCurrentSeasonId from '@modules/encoding/shared/hooks/useCurrentSeasonId';
import {
    useGetMineralFertilisationNutrientsQuery,
    useGetMineralFertilisersQuery,
    useGetNitrogenPerCropQuery,
} from '@modules/results/api/summary.api';

export const useMineralFertilisationLogic = () => {
    const { currentSeasonId } = useCurrentSeasonId();

    const {
        data: mineralFertilisationData,
        isLoading: isLoadingMineralFertilisation,
        isError: isMineralFertilisationError,
    } = useGetMineralFertilisersQuery({
        farmSeasonId: currentSeasonId,
    });

    const {
        data: nitrogenPerCropData,
        isLoading: isLoadingNitrogenPerCrop,
        isError: isNitrogenPerCropError,
    } = useGetNitrogenPerCropQuery({
        farmSeasonId: currentSeasonId,
    });

    const {
        data: mineralFertilisationNutrientsData,
        isLoading: isLoadingMineralFertilisationNutrients,
        isError: isMineralFertilisationNutrientsError,
    } = useGetMineralFertilisationNutrientsQuery({
        farmSeasonId: currentSeasonId,
    });

    const noFertilisationData = mineralFertilisationData
        ? Object.values(mineralFertilisationData).every((yearData) => yearData.length === 0)
        : true;

    const noNitrogenPerCropData = nitrogenPerCropData
        ? Object.values(nitrogenPerCropData).every((yearData) => yearData.length === 0)
        : true;

    const noMineralFertilisationNutrientsData = mineralFertilisationNutrientsData
        ? Object.values(mineralFertilisationNutrientsData).every(
              (yearData) => Array.isArray(yearData) && yearData.length === 0,
          )
        : true;

    const hasNoData =
        (noMineralFertilisationNutrientsData || isMineralFertilisationNutrientsError) &&
        (noFertilisationData || noNitrogenPerCropData || isMineralFertilisationError || isNitrogenPerCropError) &&
        !isLoadingMineralFertilisation &&
        !isLoadingNitrogenPerCrop &&
        !isLoadingMineralFertilisationNutrients;

    return { hasNoData };
};
